import { gql } from '@apollo/client';

export const VERIFY_STORE = gql`
  query verifyStore($token: String!) {
    verifyStore(token: $token) {
      error
      message
      clientId
      storeId
      storeName
      storeType
    }
  }
`;

export const VERIFY_STORE_BY_API_KEY = gql`
  query verifyStoreByApiKey($apiKey: String!) {
    verifyStoreByApiKey(apiKey: $apiKey) {
      error
      message
      clientId
      storeId
      storeName
      storeType
    }
  }
`;

export const SHOPIFY_LOGIN = gql`
  mutation shopifyLogin($input: LoginInput) {
    shopifyLogin(input: $input) {
      error
      message
      isLogin
      needRedirect
      redirectUrl
      websiteType
      data {
        status
        shopId
        shop
        adminAccessToken
      }
    }
  }
`;

export const SHOPIFY_INSTALL = gql`
  mutation shopifyInstall($input: InstallInput) {
    shopifyInstall(input: $input) {
      error
      message
      isLogin
      needRedirect
      redirectUrl
      websiteType
      data {
        status
        shopId
        shop
        adminAccessToken
      }
    }
  }
`;

export const GET_STAFFS = gql`
  query GetStaffs($page: Int, $limit: Int) {
    getStaffs(page: $page, limit: $limit) {
      error
      message
      staffs {
        id
        name
        email
        phone
        loginId
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const CREATE_STAFF = gql`
  mutation CreateStaff($name: String!, $email: String!, $phone: String) {
    createStaff(name: $name, email: $email, phone: $phone) {
      error
      message
      id
      loginId
      generatedPassword
    }
  }
`;

export const UPDATE_MY_STORE_PREFIX = gql`
  mutation UpdateMyStorePrefix($prefix: String!) {
    updateMyStorePrefix(prefix: $prefix) {
      error
      message
    }
  }
`;

export const CHECK_STORE_PREFIX = gql`
  query CheckStorePrefix($prefix: String!) {
    checkStorePrefix(prefix: $prefix) {
      error
      message
      available
    }
  }
`;

export const GET_MY_STORE = gql`
  query GetMyStore {
    getMyStore {
      storeId
      clientId
      storeName
      prefix
      storeType
      defaultResolution
    }
  }
`;

// ── External REST API key (per-store) ───────────────────────────
export const GET_MY_STORE_API_KEY = gql`
  query GetMyStoreApiKey {
    getMyStoreApiKey {
      error
      message
      apiKey
      apiKeyGeneratedAt
    }
  }
`;

export const GENERATE_MY_STORE_API_KEY = gql`
  mutation GenerateMyStoreApiKey {
    generateMyStoreApiKey {
      error
      message
      apiKey
      apiKeyGeneratedAt
    }
  }
`;

export const REVOKE_MY_STORE_API_KEY = gql`
  mutation RevokeMyStoreApiKey {
    revokeMyStoreApiKey { error message }
  }
`;

export const UPDATE_STAFF = gql`
  mutation UpdateStaff($id: ID!, $name: String, $phone: String) {
    updateStaff(id: $id, name: $name, phone: $phone) {
      error
      message
      id
    }
  }
`;

export const GENERATE_STAFF_LOGIN_ID = gql`
  mutation GenerateStaffLoginId($id: ID!) {
    generateStaffLoginId(id: $id) {
      error
      message
      loginId
    }
  }
`;

export const RESET_STAFF_PASSWORD = gql`
  mutation ResetStaffPassword($id: ID!) {
    resetStaffPassword(id: $id) {
      error
      message
    }
  }
`;

export const DELETE_STAFF = gql`
  mutation DeleteStaff($id: ID!) {
    deleteStaff(id: $id) {
      error
      message
    }
  }
`;

export const GET_WALLET = gql`
  query GetWallet {
    getWallet {
      error
      message
      wallet {
        availableCredits
        blockedCredits
      }
    }
  }
`;

export const ADD_CREDITS = gql`
  mutation AddCredits($amount: Float!) {
    addCredits(amount: $amount) {
      error
      message
      wallet {
        availableCredits
        blockedCredits
      }
    }
  }
`;

export const INITIATE_CREDIT_RECHARGE = gql`
  query InitiateCreditRecharge {
    initiateCreditRecharge {
      error
      message
      token
    }
  }
`;

// ── Model Setting ──────────────────────────────────────────────
export const GET_MODEL_SETTING = gql`
  query GetModelSetting {
    getModelSetting {
      error
      message
      models {
        id
        name
        url
        gender
      }
    }
  }
`;

export const ADD_MODEL = gql`
  mutation AddModel($name: String!, $url: String!, $gender: String) {
    addModel(name: $name, url: $url, gender: $gender) {
      error
      message
      model {
        id
        name
        url
        gender
      }
    }
  }
`;

export const UPDATE_MODEL = gql`
  mutation UpdateModel($modelId: ID!, $name: String, $url: String, $gender: String) {
    updateModel(modelId: $modelId, name: $name, url: $url, gender: $gender) {
      error
      message
      model {
        id
        name
        url
        gender
      }
    }
  }
`;

export const DELETE_MODEL = gql`
  mutation DeleteModel($modelId: ID!) {
    deleteModel(modelId: $modelId) {
      error
      message
    }
  }
`;


// ── Pose Setting ───────────────────────────────────────────────
export const GET_POSE_LISTS = gql`
  query GetPoseLists {
    getPoseLists {
      error
      message
      poseLists {
        id
        masterPoseId
        name
        imageUrl
        framing
        angle
        poseDetail
      }
    }
  }
`;

export const CREATE_POSE_LIST = gql`
  mutation CreatePoseList($input: PoseInput!) {
    createPoseList(input: $input) {
      error
      message
      poseList {
        id
        masterPoseId
        name
        imageUrl
        framing
        angle
        poseDetail
      }
    }
  }
`;

export const UPDATE_POSE_LIST = gql`
  mutation UpdatePoseList($id: ID!, $input: PoseUpdateInput!) {
    updatePoseList(id: $id, input: $input) {
      error
      message
      poseList {
        id
        masterPoseId
        name
        imageUrl
        framing
        angle
        poseDetail
      }
    }
  }
`;

export const DELETE_POSE_LIST = gql`
  mutation DeletePoseList($id: ID!) {
    deletePoseList(id: $id) {
      error
      message
    }
  }
`;

export const GET_MASTER_POSES_FOR_CLIENT = gql`
  query GetMasterPosesForClient {
    getMasterPosesForClient {
      error
      message
      masterPoses {
        id
        name
        imageUrl
        framing
        angle
        poseDetail
        visibility
      }
    }
  }
`;

export const SAVE_POSE_FROM_MASTER = gql`
  mutation SavePoseFromMaster($masterPoseId: String!, $input: PoseFromMasterInput!) {
    savePoseFromMaster(masterPoseId: $masterPoseId, input: $input) {
      error
      message
      poseList {
        id
        masterPoseId
        name
        imageUrl
        framing
        angle
        poseDetail
      }
    }
  }
`;

// ── Description Templates ──────────────────────────────────────
const DESCRIPTION_TEMPLATE_FIELDS = `
  id
  masterDescriptionTemplateId
  name
  format
  tone
  maxWords
  sections { label include maxWords }
`;

// Admin-side list — no per-staff selection (the active template is picked
// from the mobile app by each staff). Avoids the "Authentication required"
// error caused by the admin token not carrying a staffId.
export const GET_DESCRIPTION_TEMPLATES = gql`
  query GetDescriptionTemplates {
    getDescriptionTemplates {
      error
      message
      descriptionTemplates { ${DESCRIPTION_TEMPLATE_FIELDS} }
    }
  }
`;

export const GET_MASTER_DESCRIPTION_TEMPLATES_FOR_CLIENT = gql`
  query GetMasterDescriptionTemplatesForClient {
    getMasterDescriptionTemplatesForClient {
      error
      message
      masterDescriptionTemplates {
        id
        name
        format
        tone
        maxWords
        sections { label include maxWords }
      }
    }
  }
`;

export const SAVE_DESCRIPTION_TEMPLATE_FROM_MASTER = gql`
  mutation SaveDescriptionTemplateFromMaster($masterDescriptionTemplateId: String!, $input: DescriptionTemplateFromMasterInput!) {
    saveDescriptionTemplateFromMaster(masterDescriptionTemplateId: $masterDescriptionTemplateId, input: $input) {
      error
      message
      descriptionTemplate { ${DESCRIPTION_TEMPLATE_FIELDS} }
    }
  }
`;

export const UPDATE_DESCRIPTION_TEMPLATE = gql`
  mutation UpdateDescriptionTemplate($id: ID!, $input: DescriptionTemplateUpdateInput!) {
    updateDescriptionTemplate(id: $id, input: $input) {
      error
      message
      descriptionTemplate { ${DESCRIPTION_TEMPLATE_FIELDS} }
    }
  }
`;

export const DELETE_DESCRIPTION_TEMPLATE = gql`
  mutation DeleteDescriptionTemplate($id: ID!) {
    deleteDescriptionTemplate(id: $id) { error message }
  }
`;

// SELECT_DESCRIPTION_TEMPLATE intentionally not exposed here — it's a
// per-staff mutation invoked from the mobile app only.

// ── Model Expression Setting ───────────────────────────────────
export const GET_MODEL_EXPRESSION_LISTS = gql`
  query GetModelExpressionLists {
    getModelExpressionLists {
      error
      message
      modelExpressionLists {
        id
        masterModelExpressionId
        name
        expression
      }
    }
  }
`;

export const DELETE_MODEL_EXPRESSION_LIST = gql`
  mutation DeleteModelExpressionList($id: ID!) {
    deleteModelExpressionList(id: $id) {
      error
      message
    }
  }
`;

export const GET_MASTER_MODEL_EXPRESSIONS_FOR_CLIENT = gql`
  query GetMasterModelExpressionsForClient {
    getMasterModelExpressionsForClient {
      error
      message
      masterModelExpressions {
        id
        name
        expression
        visibility
      }
    }
  }
`;

export const SAVE_MODEL_EXPRESSION_FROM_MASTER = gql`
  mutation SaveModelExpressionFromMaster($masterModelExpressionId: String!, $input: ModelExpressionFromMasterInput!) {
    saveModelExpressionFromMaster(masterModelExpressionId: $masterModelExpressionId, input: $input) {
      error
      message
      modelExpressionList {
        id
        masterModelExpressionId
        name
        expression
      }
    }
  }
`;

// ── Background Setting ─────────────────────────────────────────
export const GET_BACKGROUNDS = gql`
  query GetBackgrounds {
    getBackgrounds {
      error
      message
      backgrounds {
        id
        name
        imageUrl
        color
      }
    }
  }
`;

export const ADD_BACKGROUND = gql`
  mutation AddBackground($name: String!, $imageUrl: String, $color: String) {
    addBackground(name: $name, imageUrl: $imageUrl, color: $color) {
      error
      message
      background {
        id
        name
        imageUrl
        color
      }
    }
  }
`;

export const DELETE_BACKGROUND = gql`
  mutation DeleteBackground($id: ID!) {
    deleteBackground(id: $id) {
      error
      message
    }
  }
`;

// ── Lighting Setting ───────────────────────────────────────────
export const GET_LIGHTINGS = gql`
  query GetLightings {
    getLightings {
      error
      message
      lightings {
        id
        name
      }
    }
  }
`;

export const ADD_LIGHTING = gql`
  mutation AddLighting($name: String!) {
    addLighting(name: $name) {
      error
      message
      lighting {
        id
        name
      }
    }
  }
`;

export const DELETE_LIGHTING = gql`
  mutation DeleteLighting($id: ID!) {
    deleteLighting(id: $id) {
      error
      message
    }
  }
`;

// ── Dimension ──────────────────────────────────────────────────
export const GET_DIMENSIONS = gql`
  query GetDimensions {
    getDimensions {
      error
      message
      dimensions {
        id
        name
        width
        height
        active
      }
    }
  }
`;

export const CREATE_DIMENSION = gql`
  mutation CreateDimension($name: String!, $width: Float!, $height: Float!) {
    createDimension(name: $name, width: $width, height: $height) {
      error
      message
      dimension {
        id
        name
        width
        height
        active
      }
    }
  }
`;

export const SET_ACTIVE_DIMENSION = gql`
  mutation SetActiveDimension($id: ID!) {
    setActiveDimension(id: $id) {
      error
      message
    }
  }
`;

export const DELETE_DIMENSION = gql`
  mutation DeleteDimension($id: ID!) {
    deleteDimension(id: $id) {
      error
      message
    }
  }
`;

// ── Logo Setting ───────────────────────────────────────────────
export const GET_LOGO_SETTING = gql`
  query GetLogoSetting {
    getLogoSetting {
      error
      message
      logos {
        id
        name
        url
      }
    }
  }
`;

export const ADD_LOGO = gql`
  mutation AddLogo($name: String!, $url: String!) {
    addLogo(name: $name, url: $url) {
      error
      message
      logo {
        id
        name
        url
      }
    }
  }
`;

export const DELETE_LOGO = gql`
  mutation DeleteLogo($id: ID!) {
    deleteLogo(id: $id) {
      error
      message
    }
  }
`;

// ── Position Setting ───────────────────────────────────────────
export const GET_POSITIONS = gql`
  query GetPositions {
    getPositions {
      error
      message
      positions {
        id
        name
      }
    }
  }
`;

export const ADD_POSITION = gql`
  mutation AddPosition($name: String!) {
    addPosition(name: $name) {
      error
      message
      position {
        id
        name
      }
    }
  }
`;

export const DELETE_POSITION = gql`
  mutation DeletePosition($id: ID!) {
    deletePosition(id: $id) {
      error
      message
    }
  }
`;

// ── Text Setting ───────────────────────────────────────────────
export const GET_TEXT_SETTING = gql`
  query GetTextSetting {
    getTextSetting {
      error
      message
      setting {
        id
        enabled
      }
    }
  }
`;

export const UPDATE_TEXT_SETTING = gql`
  mutation UpdateTextSetting($enabled: Boolean!) {
    updateTextSetting(enabled: $enabled) {
      error
      message
    }
  }
`;

// ── Integrations ───────────────────────────────────────────────
const STORE_INTEGRATION_FIELDS = `
  id
  name
  value
  logo
  connectorUrl
  apiKey
  connected
`;

export const GET_INTEGRATIONS = gql`
  query GetIntegrations {
    getIntegrations {
      error
      message
      integrations { ${STORE_INTEGRATION_FIELDS} }
    }
  }
`;

export const GET_AVAILABLE_STORE_INTEGRATIONS = gql`
  query GetAvailableStoreIntegrations {
    getAvailableStoreIntegrations {
      error
      message
      integrations {
        name
        value
        logo
        requires {
          apiKey
          connectorUrl
        }
        credentialLabel
      }
    }
  }
`;

export const CREATE_STORE_INTEGRATION = gql`
  mutation CreateStoreIntegration($value: String!, $connectorUrl: String, $apiKey: String) {
    createStoreIntegration(value: $value, connectorUrl: $connectorUrl, apiKey: $apiKey) {
      error
      message
      integration { ${STORE_INTEGRATION_FIELDS} }
    }
  }
`;

export const UPDATE_STORE_INTEGRATION = gql`
  mutation UpdateStoreIntegration($id: ID!, $connectorUrl: String, $apiKey: String) {
    updateStoreIntegration(id: $id, connectorUrl: $connectorUrl, apiKey: $apiKey) {
      error
      message
      integration { ${STORE_INTEGRATION_FIELDS} }
    }
  }
`;

export const DELETE_STORE_INTEGRATION = gql`
  mutation DeleteStoreIntegration($id: ID!) {
    deleteStoreIntegration(id: $id) { error message }
  }
`;

export const CONNECT_INTEGRATION = gql`
  mutation ConnectIntegration($id: ID!) {
    connectIntegration(id: $id) {
      error
      message
      integration {
        id
        connected
      }
    }
  }
`;

export const DISCONNECT_INTEGRATION = gql`
  mutation DisconnectIntegration($id: ID!) {
    disconnectIntegration(id: $id) {
      error
      message
      integration {
        id
        connected
      }
    }
  }
`;

// ── Preference Variant ──────────────────────────────────────────
export const GET_ATTRIBUTES = gql`
  query GetAttributes {
    getAttributes {
      error
      message
      attributes {
        id
        labelName
        fieldType
        fieldValues {
          id
          value
        }
      }
    }
  }
`;

export const GET_PREFERENCE_VARIANT = gql`
  query GetPreferenceVariant {
    getPreferenceVariant {
      error
      message
      setting {
        id
        attributeId
        attributeName
        fieldValues {
          id
          value
        }
      }
    }
  }
`;

export const SAVE_PREFERENCE_VARIANT = gql`
  mutation SavePreferenceVariant(
    $attributeId: String!
    $attributeName: String!
    $fieldValues: [FieldValueInput!]!
  ) {
    savePreferenceVariant(
      attributeId: $attributeId
      attributeName: $attributeName
      fieldValues: $fieldValues
    ) {
      error
      message
    }
  }
`;

// ── Grouping Preference Variant ──────────────────────────────────
export const GET_GROUP_PREFERENCE_VARIANT = gql`
  query GetGroupPreferenceVariant {
    getGroupPreferenceVariant {
      error
      message
      setting {
        id
        attributeId
        attributeName
        fieldValues {
          id
          value
        }
      }
    }
  }
`;

export const SAVE_GROUP_PREFERENCE_VARIANT = gql`
  mutation SaveGroupPreferenceVariant(
    $attributeId: String!
    $attributeName: String!
    $fieldValues: [FieldValueInput!]!
  ) {
    saveGroupPreferenceVariant(
      attributeId: $attributeId
      attributeName: $attributeName
      fieldValues: $fieldValues
    ) {
      error
      message
    }
  }
`;

// ── Communication ───────────────────────────────────────────────
export const GET_COMMUNICATION_CENTER_TOKEN = gql`
  query GetCommunicationCenterToken {
    getCommunicationCenterToken {
      error
      message
      token
    }
  }
`;

// ── Wallet History ────────────────────────────────────────────────
export const GET_WALLET_HISTORY = gql`
  query GetWalletHistory($limit: Int, $offset: Int, $status: String) {
    getWalletHistory(limit: $limit, offset: $offset, status: $status) {
      history {
        _id
        operationType
        creditsUsed
        status
        usedCreditByAPI
        errorMessage
        availableCreditsBeforeOperation
        availableCreditsAfterOperation
        blockedCredits
        creationDate
        staffId {
          name
          email
        }
      }
      count
    }
  }
`;

// ── Admin Products ────────────────────────────────────────────────
export const ADMIN_GET_PRODUCTS = gql`
  query AdminGetProducts($search: String, $page: Int, $limit: Int, $status: String) {
    adminGetProducts(search: $search, page: $page, limit: $limit, status: $status) {
      error
      message
      products {
        id
        title
        description
        imageUrls
        sellingPrice
        mrp
        discount
        quantity
        variantAttributeName
        variantCount
        tags { id name }
        status
        createdAt
      }
      total
      page
      totalPages
      hasMore
    }
  }
`;

export const ADMIN_GET_PRODUCT = gql`
  query AdminGetProduct($id: ID!) {
    adminGetProduct(id: $id) {
      error
      message
      product {
        id
        title
        description
        imageUrls
        sellingPrice
        mrp
        discount
        quantity
        variantAttributeId
        variantAttributeName
        variants { id value }
        tags { id name }
        status
        createdAt
      }
    }
  }
`;

export const ADMIN_UPDATE_PRODUCT = gql`
  mutation AdminUpdateProduct(
    $id: ID!
    $title: String
    $description: String
    $sellingPrice: Float
    $mrp: Float
    $discount: Float
    $status: String
    $tags: [TagInput]
    $addVariants: [VariantValueInput]
  ) {
    adminUpdateProduct(
      id: $id
      title: $title
      description: $description
      sellingPrice: $sellingPrice
      mrp: $mrp
      discount: $discount
      status: $status
      tags: $tags
      addVariants: $addVariants
    ) {
      error
      message
      success
    }
  }
`;

export const ADMIN_GET_TAG_LIST = gql`
  query AdminGetTagList($cursor: String, $limit: Int) {
    adminGetTagList(cursor: $cursor, limit: $limit) {
      error
      message
      tags { id name }
      nextCursor
      hasMore
    }
  }
`;

// ── Product Category Setting ──────────────────────────────────────
export const GET_PRODUCT_CATEGORIES = gql`
  query GetProductCategories {
    getProductCategories {
      error
      message
      productCategories {
        id
        masterCategoryId
        name
        types
        optionalTypes
        resolution
      }
    }
  }
`;

export const SAVE_PRODUCT_CATEGORY_FROM_MASTER = gql`
  mutation SaveProductCategoryFromMaster($masterCategoryId: String!, $name: String!, $types: [String], $optionalTypes: [String], $resolution: String) {
    saveProductCategoryFromMaster(masterCategoryId: $masterCategoryId, name: $name, types: $types, optionalTypes: $optionalTypes, resolution: $resolution) {
      error
      message
      productCategory {
        id
        masterCategoryId
        name
        types
        optionalTypes
        resolution
      }
    }
  }
`;

export const CREATE_PRODUCT_CATEGORY = gql`
  mutation CreateProductCategory($name: String!) {
    createProductCategory(name: $name) {
      error
      message
      productCategory {
        id
        name
        types
      }
    }
  }
`;

export const DELETE_PRODUCT_CATEGORY = gql`
  mutation DeleteProductCategory($id: ID!) {
    deleteProductCategory(id: $id) {
      error
      message
    }
  }
`;

export const ADD_PRODUCT_CATEGORY_TYPE = gql`
  mutation AddProductCategoryType($id: ID!, $typeName: String!) {
    addProductCategoryType(id: $id, typeName: $typeName) {
      error
      message
      productCategory {
        id
        name
        types
      }
    }
  }
`;

export const REMOVE_PRODUCT_CATEGORY_TYPE = gql`
  mutation RemoveProductCategoryType($id: ID!, $typeName: String!) {
    removeProductCategoryType(id: $id, typeName: $typeName) {
      error
      message
      productCategory {
        id
        name
        types
      }
    }
  }
`;

// ── Master Product Categories (for admin selection) ───────────────
export const GET_MASTER_PRODUCT_CATEGORIES_FOR_CLIENT = gql`
  query GetMasterProductCategoriesForClient {
    getMasterProductCategoriesForClient {
      error
      message
      masterProductCategories {
        id
        name
        types
        optionalTypes
        resolution
        visibility
      }
    }
  }
`;

// ── Dashboard Analytics ────────────────────────────────────────────
export const GET_DASHBOARD_ANALYTICS = gql`
  query GetDashboardAnalytics($fromDate: String, $toDate: String) {
    getDashboardAnalytics(fromDate: $fromDate, toDate: $toDate) {
      wallet {
        availableCredits
        blockedCredits
      }
      products {
        total
        active
        draft
      }
      staff {
        total
      }
      creditHistory {
        totalCreditsUsed
        transactionCount
        dailyUsage {
          date
          credits
          count
        }
        statusBreakdown {
          status
          count
        }
        recentTransactions {
          _id
          operationType
          creditsUsed
          status
          availableCreditsAfterOperation
          creationDate
          staffName
        }
      }
    }
  }
`;
